import { TabOption } from './types';

export type XCollection = {
  [tabId: string]: TabOption;
};

export const measureTabWidths = (element: HTMLElement): XCollection => {
  const children = Array.from(element.childNodes) as HTMLElement[];
  return Object.fromEntries(
    children.map(child => {
      const tabId = child.dataset.tabId;
      const width = child.getBoundingClientRect().width;
      if (typeof tabId !== 'string') {
        throw new Error('tabId not found.');
      }
      return [tabId, { tabId, width }];
    })
  );
};
